import React from "react";
import styled from "@emotion/styled";
import { Skeleton } from "antd5";
import { Flex } from "styles/utility-components";

import { SavedViewType } from "components/my_feed/saved_views_bar/types";
import { ListNewSavedViewsResponse, PinnedSavedViewDto } from "lib/generated/app-api";
import { useMyFeedPageState } from "../../components/my_feed/useMyFeedPageState";
import PinnedViewsList from "../../components/my_feed/views_bar/PinnedViewsList";

const filteredAllViews = (
  allViews: ListNewSavedViewsResponse["savedViews"],
  pinnedViews: PinnedSavedViewDto[],
) => {
  const pinnedView = pinnedViews.map((view) => allViews.find((v) => v.id === view.savedViewId));
  return pinnedView.filter((view) => view !== undefined) as SavedViewType[];
};

function VerticalViews() {
  const { allViews, pinnedViews, isLoadingViews } = useMyFeedPageState();

  if (isLoadingViews) {
    return <Skeleton />;
  }

  if (!allViews || !pinnedViews) {
    return null;
  }
  return (
    <VerticalViewsContainer>
      <PinnedViewsList pinnedViews={filteredAllViews(allViews, pinnedViews)} />
    </VerticalViewsContainer>
  );
}

export default VerticalViews;

const VerticalViewsContainer = styled(Flex)`
  padding: 16px;
`;
